{createContext} = require 'react'

context = createContext
	dispatch: null

export default context